var escape = require("../../../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button-bg[data-v-52955de5]{background:url(" + escape(require("../../../assets/images/button_blue.png")) + ");background-size:100% 100%}", ""]);

// exports
